module.exports = __webpack_public_path__ + "img/logo.745b75b4.svg";